const style = (theme): any => ({
    root: {
        display: 'flex',
        flex: 1,
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    },
    partnerInfoLabel: {
        color: theme.palette.secondary.light,
    },
});
export default style;
